import { FormFormattedField, FormInput } from 'components';
import { StyledField, StyledGrid, StyledLabel } from '../ui';
import { normalizeFormattedField } from 'utils';
import { composeValidators, required, validateMinBid, validateMinOffer } from 'utils/validators';
import { useForm } from 'react-final-form';
import { useIsAlternativeAuction } from 'hooks';
import { Vehicle } from 'types/vehicle';
import { AUCTION_TYPES } from 'constants';
import { useStartingBidValidator } from 'hooks/useGetValidators';
import { getHighestBid } from 'utils/vehicle';

export const StartingBidField = () => {
  const form = useForm();
  const { values } = form.getState();

  const auctionType = values.auction?.type || AUCTION_TYPES.AUTOAXESS;
  const validateStartingBid = useStartingBidValidator(auctionType);

  const highestBid = getHighestBid(values);

  console.log(highestBid, 'highestBid');

  return (
    <StyledGrid item xs={12}>
      <StyledLabel>Starting/Min bid</StyledLabel>
      <StyledField
        name="starting_bid"
        component={FormFormattedField}
        placeholder="100$"
        // @ts-ignore
        thousandSeparator
        allowNegative={false}
        fixedDecimalScale
        prefix="$"
        customInput={FormInput}
        parse={normalizeFormattedField}
        disableUnderline
        disabled={highestBid.amount !== 0}
        validate={composeValidators(...validateStartingBid)}
      />
    </StyledGrid>
  );
};
